// Génère un EAN13 numérique (12 chiffres) à partir des données du lot.
// JsBarcode (format EAN13) calcule automatiquement le 13ème chiffre de contrôle.
// Préfixe "200" : réservé GS1 pour les codes internes / produits non commerciaux.
// Déterministe : même (sku, lot_number) => même code.
export function generateEAN13(sku, lotNumber) {
  const str = `${sku || ""}|${lotNumber || ""}`;
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }
  const numeric = Math.abs(hash).toString().padStart(9, "0").slice(-9);
  return "200" + numeric;
}

// Calcule le chiffre de contrôle EAN13 (13ème chiffre) depuis les 12 premiers.
// Algorithme officiel GS1 : somme pondérée (1,3,1,3,...) puis (10 - somme%10) % 10.
export function ean13CheckDigit(base12) {
  const digits = String(base12 || "").replace(/\D/g, "").slice(0, 12);
  if (digits.length !== 12) return null;
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += Number(digits[i]) * (i % 2 === 0 ? 1 : 3);
  }
  return (10 - (sum % 10)) % 10;
}

// Retourne le code EAN13 complet (13 chiffres) à partir d'une saisie
// de 12 ou 13 chiffres. Vide si saisie invalide.
export function normalizeEAN13(input) {
  const digits = String(input || "").replace(/\D/g, "");
  if (digits.length === 13) return digits;
  if (digits.length === 12) {
    const cd = ean13CheckDigit(digits);
    return cd == null ? "" : digits + String(cd);
  }
  return "";
}
